module.exports = __webpack_public_path__ + "static/media/photo18.dc26ff0f.jpg";